export const MemberClassCode = {
  LEVEL_00: 'LEVEL_00',
  LEVEL_01: 'LEVEL_01',
  FLIGHT_00: 'FLIGHT_00',
  FLIGHT_01: 'FLIGHT_01',
}

export type TMemberClassCode = keyof typeof MemberClassCode

export interface IGetMemberClassResponse {
  memberClassList: {
    memberNo: string
    classTypeCode: 'SALES' | 'FLIGHT'
    classCode: TMemberClassCode
    startAt?: string
    endAt?: string
    appliedAt?: string
    firstStartAt?: string
  }[]
}

export interface MemberClassBenefitsResponse {
  /** 혜택 목록 */
  benefits: TMemberClassBenefit[]
  /** 뱃지 (for 통합주문) */
  badge?: TMemberClassBadge
  /** 뱃지 (for 해외주문) */
  globalBadge?: TMemberClassGlobalBadge
}

export const MemberClassBenefits = {
  DOMESTIC_PRICE_GOLD_CLASS: 'DOMESTIC_PRICE_GOLD_CLASS',
  GLOBAL_PRICE_GOLD_CLASS: 'GLOBAL_PRICE_GOLD_CLASS',
  LEISURE_PRICE_GOLD_CLASS: 'LEISURE_PRICE_GOLD_CLASS',
  PAYMENT_REWARD_SILVER_CLASS: 'PAYMENT_REWARD_SILVER_CLASS',
  PAYMENT_REWARD_GOLD_CLASS: 'PAYMENT_REWARD_GOLD_CLASS',
  PAYMENT_REWARD_PLATINUM_CLASS: 'PAYMENT_REWARD_PLATINUM_CLASS',
  FESTIVAL_GOLD_CLASS: 'FESTIVAL_GOLD_CLASS',
  WELCOME_COUPON: 'WELCOME_COUPON',
  MONTHLY_COUPON: 'MONTHLY_COUPON',
  GOLD_CLASS_TRIAL: 'GOLD_CLASS_TRIAL',
}
export type TMemberClassBenefit = keyof typeof MemberClassBenefits

// 키 선언 순서 = 등급 오름차순. 이 순서를 우선순위로 사용하는 로직이 있으므로 순서를 유지할 것.
export const MemberClassBadge = {
  SILVER_CLASS: 'SILVER_CLASS',
  GOLD_CLASS: 'GOLD_CLASS',
  PLATINUM_CLASS: 'PLATINUM_CLASS',
} as const
export type TMemberClassBadge = keyof typeof MemberClassBadge

export const MemberClassGlobalBadge = {
  SILVER_CLASS: 'SILVER_CLASS',
  GOLD_CLASS: 'GOLD_CLASS',
  PLATINUM_CLASS: 'PLATINUM_CLASS',
  FLIGHT_ORDER: 'FLIGHT_ORDER',
}
export type TMemberClassGlobalBadge = keyof typeof MemberClassGlobalBadge
